<ng-select
  class="searchable"
  [items]="items"
  bindLabel="name"
  [multiple]="true"
  [searchable]="true"
  [closeOnSelect]="false"
  [clearable]="false"
  [disabled]="isDisabled"
  [ngModel]="value"
  (ngModelChange)="onSelectChange($event)"
  groupBy="selectAll"
  [selectableGroup]="true"
  [selectableGroupAsModel]="false"
  (open)="onDropdownOpen()"
  (close)="onCloseDropdown()"
  [dropdownPosition]="'auto'"
  (search)="onSearch($event)"
  [placeholder]="selectedCount + ('selectDeselectServiceProvider.selectedProvidersPlaceholder' | translate)"
  [compareWith]="compareItems"
  [ngClass]="extendedView ? 'extended-view-' + columnsCount : ''"
  [attr.title]="
    !isDropdownOpen
      ? selectedCount + ' ' + ('selectDeselectServiceProvider.selectedProvidersPlaceholder' | translate)
      : null
  "
>
  <!-- Custom optgroup: Select All Checkbox -->
  <ng-template
    ng-optgroup-tmp
    let-item="item"
  >
    <span
      *ngIf="isSearchActive ? false : items.length > 1"
      class="ng-option-label"
    >
      <span>{{ item.selectAll }}</span>
    </span>
  </ng-template>

  <!-- Custom item template -->
  <ng-template
    ng-option-tmp
    let-item="item"
  >
    <span
      class="ng-option-label"
      [attr.title]="item.name"
    >
      <span>{{ item.name }}</span>
    </span>
  </ng-template>

  <!-- Multi-label template so that it shows “X items selected” instead of tags -->
  <ng-template
    ng-multi-label-tmp
    let-items="items"
  >
    <div
      *ngIf="!isSearchActive"
      class="ng-value"
    >
      <span class="ng-value-label">
        {{ items.length }} {{ 'selectDeselectServiceProvider.selectedProvidersPlaceholder' | translate }}
      </span>
    </div>
  </ng-template>

  <!-- Custom Footer for Extend/Collapse View -->
  <ng-template
    ng-footer-tmp
    *ngIf="isSearchActive ? visibleItemsAfterSearch.length >= 5 : items.length >= 5"
  >
    <div class="dropdown-footer d-flex justify-content-center align-items-center d-none d-md-flex">
      <a
        class="pointer text-center"
        href="#"
        (click)="toggleExtendView($event)"
      >
        {{
          extendedView
            ? ('selectDeselectServiceProvider.selectDropdownCollapseView' | translate)
            : ('selectDeselectServiceProvider.selectDropdownExtendView' | translate)
        }}
        <span class="d-block">
          <i
            class="fa-solid fa-fw"
            [ngClass]="extendedView ? 'fa-chevron-up' : 'fa-chevron-down'"
          ></i>
        </span>
      </a>
    </div>
  </ng-template>
</ng-select>
